import React from 'react'
import "./FindTrusted.css";
import nametitle1 from '../images/png/Rectangle 171.png'
import nametitle2 from '../images/png/Rectangle 171 (1).png'
import nametitle3 from '../images/png/Rectangle 171 (2).png'
import nametitle4 from '../images/png/Rectangle 171 (3).png'
import nametitle5 from '../images/png/Rectangle 171 (4).png'
import namestar from '../images/png/png-transparent-spain-sea-salt-20-minutos-brand-verified-stamp-angle-text-logo-removebg-preview 2.png'

const FindTrusted=()=>{
  return (
    <div>
        <div className='findtrust'>
            <div className='seemore'>
                <div className='find'>
                    <h1>Find Trusted Associate</h1>
                    <p>Find the best Fliqa Associate for your special day.</p>
                </div>
                <h3>See More {'>>'}</h3>   
            </div>
            <div className='nametitle'>
                <div className='namecard'>
                    <div className='cardimg'>
                        <img src={nametitle1} alt="err"/>     
                    </div>
                    <div className='cardname'>
                        <div className='find'>
                            <h4>Name Title</h4>
                            <p>Location:</p>
                        </div>
                         <img src={namestar} alt="err"/> 
                    </div>
                    
                </div>
                <div className='namecard'>
                    <div className='cardimg'>
                        <img src={nametitle2} alt="err"/>     
                    </div>
                    <div className='cardname'>
                        <div className='find'>
                            <h4>Name Title</h4>
                            <p>Location:</p>
                        </div>
                         {/* <img src={namestar} alt="err"/>  */}
                    </div>
                    
                </div>
                <div className='namecard'>
                    <div className='cardimg'>
                        <img src={nametitle3} alt="err"/>     
                    </div>
                    <div className='cardname'>
                        <div className='find'>
                            <h4>Name Title</h4>
                            <p>Location:</p>
                        </div>
                         <img src={namestar} alt="err"/> 
                    </div>
                    
                </div>
                <div className='namecard'>
                    <div className='cardimg'>
                        <img src={nametitle4} alt="err"/>     
                    </div>
                    <div className='cardname'>
                        <div className='find'>
                            <h4>Name Title</h4>
                            <p>Location:</p>
                        </div>
                         {/* <img src={namestar} alt="err"/>  */}
                    </div>
                    
                </div>
                <div className='namecard'>
                    <div className='cardimg'>
                        <img src={nametitle5} alt="err"/>     
                    </div>
                    <div className='cardname'>
                        <div className='find'>
                            <h4>Name Title</h4>
                            <p>Location:</p>
                        </div>
                         <img src={namestar} alt="err"/> 
                    </div>
                    
                </div>
                
            </div>
            
            
        </div>
    </div>
  )
}
export {FindTrusted}
